/* KX motion engine — Korrect premium layer.
   Depends on GSAP 3 + ScrollTrigger (loaded before this file).
   Progressive: if GSAP is missing or the visitor prefers reduced motion,
   content is simply shown. */
(function () {
  'use strict';

  var html = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && window.matchMedia('(pointer: fine)').matches;
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  function headerOffset() {
    var h = document.querySelector('.header');
    return h ? Math.round(h.getBoundingClientRect().height) : 0;
  }
  function setHeaderVar() {
    html.style.setProperty('--kx-header-h', headerOffset() + 'px');
    var hero = document.querySelector('.kx-hero');
    if (hero) {
      var top = hero.getBoundingClientRect().top + (window.pageYOffset || html.scrollTop);
      hero.style.setProperty('--kx-hero-offset', Math.max(0, Math.round(top)) + 'px');
    }
  }

  function showAll() {
    html.classList.remove('kx-js');
    html.classList.add('kx-static');
  }

  /* ---------- static fallbacks (no GSAP / reduced motion) ---------- */
  function initStatic() {
    $$('[data-kx="acc"]').forEach(function (el) {
      var btn = el.querySelector('.kx-acc__btn');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var open = el.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    $$('video.kx-lazy').forEach(function (v) { if (v.dataset.src && !v.src) { v.src = v.dataset.src; v.play && v.play().catch(function () {}); } });
    $$('[data-kx="chapter"]').forEach(function (el) {
      var base = el.querySelector('.kx-chapter__img[data-beat="base"]') || el.querySelector('.kx-chapter__img');
      if (base) base.style.opacity = 1;
      $$('.kx-beat', el).forEach(function (b) { b.classList.add('is-active'); });
    });
    $$('[data-kx="hscroll"]').forEach(function (el) { el.classList.add('kx-rail--native'); });
    setHeaderVar();
  }

  if (reduce || !window.gsap || !window.ScrollTrigger) {
    showAll();
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initStatic); else initStatic();
    return;
  }

  gsap.registerPlugin(ScrollTrigger);
  ScrollTrigger.config({ ignoreMobileResize: true });
  html.classList.add('kx-motion');

  /* ---------- text splitting ---------- */
  function splitWords(el, mask) {
    if (el.dataset.kxSplit) return $$('.kx-wi', el);
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      var text = node.nodeValue;
      if (!text.trim()) return;
      var frag = document.createDocumentFragment();
      text.split(/(\s+)/).forEach(function (part) {
        if (!part) return;
        if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
        var outer = document.createElement('span');
        outer.className = mask ? 'kx-w kx-w--mask' : 'kx-w';
        var inner = document.createElement('span');
        inner.className = 'kx-wi';
        inner.textContent = part;
        outer.appendChild(inner);
        frag.appendChild(outer);
      });
      node.parentNode.replaceChild(frag, node);
    });
    el.dataset.kxSplit = '1';
    return $$('.kx-wi', el);
  }

  /* ---------- primitives ---------- */
  function rise(el) {
    var staggered = el.hasAttribute('data-kx-stagger');
    var items = staggered ? Array.prototype.slice.call(el.children) : [el];
    var dist = parseFloat(el.dataset.kxY || 28);
    if (staggered) gsap.set(el, { opacity: 1 });
    gsap.set(items, { opacity: 0, y: dist });
    gsap.to(items, {
      opacity: 1, y: 0, duration: 1.05, ease: 'power3.out',
      stagger: parseFloat(el.dataset.kxStagger) || 0.08,
      scrollTrigger: { trigger: el, start: 'top 88%', once: true },
      onComplete: function () { gsap.set(items, { clearProps: 'transform,opacity' }); }
    });
  }

  function lines(el) {
    var w = splitWords(el, true);
    gsap.set(el, { opacity: 1 });
    gsap.set(w, { yPercent: 115 });
    gsap.to(w, {
      yPercent: 0, duration: 1.15, ease: 'power4.out', stagger: 0.045,
      scrollTrigger: { trigger: el, start: 'top 86%', once: true },
      onComplete: function () { gsap.set(w, { clearProps: 'transform' }); }
    });
  }

  function words(el) {
    var w = splitWords(el, false);
    gsap.set(el, { opacity: 1 });
    gsap.fromTo(w, { opacity: 0.38 }, {
      opacity: 1, ease: 'none', stagger: 0.04,
      scrollTrigger: { trigger: el, start: 'top 82%', end: 'bottom 60%', scrub: 0.35 }
    });
  }

  function scale(el) {
    gsap.fromTo(el, { scale: 0.9, opacity: 0.55 }, {
      scale: 1, opacity: 1, ease: 'none',
      scrollTrigger: { trigger: el, start: 'top 96%', end: 'top 52%', scrub: 0.5 }
    });
    if (el.hasAttribute('data-kx-dim')) {
      gsap.to(el, {
        opacity: 0.28, scale: 0.97, ease: 'none',
        scrollTrigger: { trigger: el, start: 'bottom 38%', end: 'bottom 2%', scrub: 0.5 }
      });
    }
  }

  function parallax(el) {
    var speed = parseFloat(el.dataset.kxSpeed || 0.25);
    gsap.fromTo(el, { y: speed * 120 }, {
      y: -speed * 120, ease: 'none',
      scrollTrigger: { trigger: el.parentElement, start: 'top bottom', end: 'bottom top', scrub: true }
    });
  }

  function count(el) {
    var raw = (el.dataset.kxTo || el.textContent).replace(/[^0-9.]/g, '');
    var to = parseFloat(raw) || 0;
    var decimals = parseInt(el.dataset.kxDecimals || 0, 10);
    var prefix = el.dataset.kxPrefix || '';
    var suffix = el.dataset.kxSuffix || '';
    var obj = { v: 0 };
    var fmt = function (v) {
      var s = decimals ? v.toFixed(decimals) : Math.round(v).toLocaleString('en-US');
      return prefix + s + suffix;
    };
    el.textContent = fmt(0);
    gsap.to(obj, {
      v: to, duration: 1.8, ease: 'power3.out',
      scrollTrigger: { trigger: el, start: 'top 90%', once: true },
      onUpdate: function () { el.textContent = fmt(obj.v); }
    });
  }

  /* ---------- hero ---------- */
  function hero(el) {
    var title = el.querySelector('.kx-hero__title');
    var eyebrow = el.querySelector('.kx-hero__eyebrow');
    var lead = el.querySelector('.kx-hero__lead');
    var ctas = el.querySelector('.kx-hero__ctas');
    var stage = el.querySelector('.kx-hero__stage');
    var product = el.querySelector('.kx-hero__product');
    var glow = el.querySelector('.kx-hero__glow');
    var bgs = $$('.kx-hero__video, .kx-hero__poster', el);
    var copy = el.querySelector('.kx-hero__copy');
    var cue = el.querySelector('.kx-hero__scrollcue');

    var tl = gsap.timeline({ defaults: { ease: 'power4.out' }, delay: 0.1 });
    if (title) {
      var w = splitWords(title, true);
      gsap.set(title, { opacity: 1 });
      gsap.set(w, { yPercent: 115 });
      tl.to(w, { yPercent: 0, duration: 1.3, stagger: 0.06 }, 0);
    }
    if (eyebrow) tl.fromTo(eyebrow, { opacity: 0, y: 14 }, { opacity: 1, y: 0, duration: 0.9 }, 0.15);
    if (lead) tl.fromTo(lead, { opacity: 0, y: 22 }, { opacity: 1, y: 0, duration: 1 }, 0.55);
    if (ctas) tl.fromTo(ctas.children, { opacity: 0, y: 18 }, { opacity: 1, y: 0, duration: 0.9, stagger: 0.08 }, 0.75);
    if (product) tl.fromTo(product, { opacity: 0, y: 90, scale: 0.86 }, { opacity: 1, y: 0, scale: 1, duration: 1.6, ease: 'expo.out' }, 0.45);
    if (glow) tl.fromTo(glow, { opacity: 0, scale: 0.6 }, { opacity: 1, scale: 1, duration: 1.8 }, 0.6);
    if (cue) tl.fromTo(cue, { opacity: 0 }, { opacity: 1, duration: 1 }, 1.6);

    var st = { trigger: el, start: 'top top', end: 'bottom top', scrub: true };
    if (copy) gsap.to(copy, { opacity: 0, y: -60, ease: 'none', scrollTrigger: st });
    if (stage) gsap.to(stage, { y: -140, scale: 0.86, opacity: 0.15, ease: 'none', scrollTrigger: st });
    if (bgs.length) gsap.to(bgs, { scale: 1.12, ease: 'none', scrollTrigger: st });
    if (cue) gsap.to(cue, { opacity: 0, ease: 'none', scrollTrigger: { trigger: el, start: 'top top', end: '25% top', scrub: true } });

    if (product) {
      gsap.to(product, { y: '-=10', duration: 3.2, ease: 'sine.inOut', yoyo: true, repeat: -1, delay: 2.1 });
    }

    // Safety: rAF is paused in hidden/background tabs, which would leave the
    // intro frozen at opacity 0. Show the final state instead of nothing.
    if (document.visibilityState !== 'visible') tl.progress(1);
    setTimeout(function () { if (tl.progress() === 0) tl.progress(1); }, 3500);
  }

  /* ---------- sticky chapter with media crossfade ---------- */
  function chapter(el) {
    var beats = $$('.kx-beat', el);
    var imgs = $$('.kx-chapter__img', el);
    var base = el.querySelector('.kx-chapter__img[data-beat="base"]');
    var bar = el.querySelector('.kx-chapter__progress span');
    var current = null;

    function swap(i) {
      if (!imgs.length) return;
      var target = el.querySelector('.kx-chapter__img[data-beat="' + i + '"]') || base || imgs[0];
      if (!target || target === current) return;
      current = target;
      imgs.forEach(function (im) {
        if (im === target) gsap.to(im, { opacity: 1, scale: 1, duration: 0.9, ease: 'power3.out', overwrite: true });
        else gsap.to(im, { opacity: 0, scale: 1.04, duration: 0.7, ease: 'power2.out', overwrite: true });
      });
    }

    beats.forEach(function (b, i) {
      ScrollTrigger.create({
        trigger: b, start: 'top 62%', end: 'bottom 38%',
        onEnter: function () { b.classList.add('is-active'); swap(i); },
        onEnterBack: function () { b.classList.add('is-active'); swap(i); },
        onLeave: function () { b.classList.remove('is-active'); },
        onLeaveBack: function () { b.classList.remove('is-active'); }
      });
      var inner = b.querySelector('.kx-beat__inner');
      if (inner) {
        gsap.fromTo(inner, { opacity: 0, y: 36 }, {
          opacity: 1, y: 0, duration: 1, ease: 'power3.out',
          scrollTrigger: { trigger: b, start: 'top 85%', once: true }
        });
      }
    });

    var beatsWrap = el.querySelector('.kx-chapter__beats');
    if (bar && beatsWrap) {
      gsap.to(bar, { scaleX: 1, ease: 'none', scrollTrigger: { trigger: beatsWrap, start: 'top 60%', end: 'bottom 60%', scrub: 0.3 } });
    }

    var media = el.querySelector('.kx-chapter__media');
    if (media) {
      gsap.fromTo(media, { scale: 0.92, opacity: 0 }, {
        scale: 1, opacity: 1, duration: 1.4, ease: 'expo.out',
        scrollTrigger: { trigger: el, start: 'top 75%', once: true }
      });
    }
    if (imgs.length) { gsap.set(imgs, { opacity: 0 }); swap(0); }
  }

  /* ---------- pinned horizontal rail ---------- */
  function hscroll(el) {
    var track = el.querySelector('.kx-rail__track');
    if (!track) return;
    var wide = window.matchMedia('(min-width: 900px)').matches;

    function dist() {
      var pad = parseFloat(getComputedStyle(track).paddingRight) || 0;
      return Math.max(0, track.scrollWidth - el.clientWidth + pad);
    }

    // Only pin when the whole rail fits under the header; otherwise native scroll.
    var fits = el.offsetHeight <= (window.innerHeight - headerOffset() - 8);
    if (!wide || !fits || dist() < 40) {
      el.classList.add('kx-rail--native');
      $$('.kx-rail__card', el).forEach(function (c) { rise(c); });
      return;
    }

    el.classList.add('kx-rail--pinned');
    var tween = gsap.to(track, {
      x: function () { return -dist(); },
      ease: 'none',
      scrollTrigger: {
        trigger: el,
        start: function () { return 'top ' + headerOffset(); },
        end: function () { return '+=' + dist(); },
        scrub: 0.8,
        pin: true,
        anticipatePin: 1,
        invalidateOnRefresh: true
      }
    });

    $$('.kx-rail__card', el).forEach(function (c) {
      gsap.fromTo(c, { scale: 0.94, opacity: 0.5 }, {
        scale: 1, opacity: 1, ease: 'none',
        scrollTrigger: { trigger: c, containerAnimation: tween, start: 'left 95%', end: 'left 65%', scrub: true }
      });
    });
    var bar = el.querySelector('.kx-rail__progress span');
    if (bar) gsap.to(bar, { scaleX: 1, ease: 'none', scrollTrigger: { trigger: el, start: function () { return 'top ' + headerOffset(); }, end: function () { return '+=' + dist(); }, scrub: true } });
  }

  /* ---------- stacking cards ---------- */
  function stack(el) {
    var cards = $$('.kx-stack__card', el);
    var n = cards.length;
    if (window.innerWidth < 900 || n < 2) {
      cards.forEach(function (c) { var inner = c.querySelector('.kx-stack__inner'); if (inner) rise(inner); });
      return;
    }
    var top = headerOffset() + 24;
    cards.forEach(function (c, i) {
      c.style.top = (top + i * 14) + 'px';
      if (i < n - 1) {
        gsap.to(c, {
          scale: 1 - (n - 1 - i) * 0.035, opacity: 0.55, ease: 'none',
          scrollTrigger: { trigger: cards[i + 1], start: 'top bottom', end: 'top ' + (top + (i + 1) * 14) + 'px', scrub: true }
        });
      }
      var inner = c.querySelector('.kx-stack__inner');
      if (inner) gsap.fromTo(inner.children, { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: 1, stagger: 0.08, ease: 'power3.out', scrollTrigger: { trigger: c, start: 'top 80%', once: true } });
    });
  }

  /* ---------- accordion ---------- */
  function accordion(el) {
    var btn = el.querySelector('.kx-acc__btn');
    var panel = el.querySelector('.kx-acc__panel');
    if (!btn || !panel) return;
    gsap.set(panel, { height: 0, opacity: 0 });
    btn.addEventListener('click', function () {
      var open = el.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      gsap.to(panel, open
        ? { height: 'auto', opacity: 1, duration: 0.55, ease: 'power3.out', onComplete: function () { ScrollTrigger.refresh(); } }
        : { height: 0, opacity: 0, duration: 0.4, ease: 'power3.inOut', onComplete: function () { ScrollTrigger.refresh(); } });
    });
  }

  /* ---------- magnetic buttons ---------- */
  function magnetic(btn) {
    if (!fine) return;
    var strength = 0.22;
    btn.addEventListener('mousemove', function (e) {
      var r = btn.getBoundingClientRect();
      gsap.to(btn, { x: (e.clientX - (r.left + r.width / 2)) * strength, y: (e.clientY - (r.top + r.height / 2)) * strength, duration: 0.5, ease: 'power3.out' });
    });
    btn.addEventListener('mouseleave', function () {
      gsap.to(btn, { x: 0, y: 0, duration: 0.7, ease: 'elastic.out(1, 0.5)' });
    });
  }

  /* ---------- lazy video ---------- */
  function lazyVideo(v) {
    function start() { if (v.dataset.src && !v.getAttribute('src')) v.src = v.dataset.src; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    if (!('IntersectionObserver' in window)) { start(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) start(); else v.pause(); });
    }, { rootMargin: '240px 0px' });
    io.observe(v);
  }

  /* ---------- nav state ---------- */
  function nav() {
    var last = -1;
    function tick() {
      var y = window.pageYOffset || html.scrollTop;
      var s = y > 12;
      if (s !== last) { html.classList.toggle('kx-scrolled', s); last = s; }
    }
    window.addEventListener('scroll', tick, { passive: true });
    tick();
    setHeaderVar();
  }

  /* ---------- init ---------- */
  var handlers = {
    rise: rise, lines: lines, words: words, scale: scale, parallax: parallax, count: count,
    hero: hero, chapter: chapter, hscroll: hscroll, stack: stack, acc: accordion
  };

  function initIn(root) {
    $$('[data-kx]', root).forEach(function (el) {
      if (el.dataset.kxInit) return;
      var type = el.dataset.kx;
      if (handlers[type]) { el.dataset.kxInit = '1'; handlers[type](el); }
    });
    $$('.kx-btn', root).forEach(function (b) { if (!b.dataset.kxMag) { b.dataset.kxMag = '1'; magnetic(b); } });
    $$('video.kx-lazy', root).forEach(function (v) { if (!v.dataset.kxLazy) { v.dataset.kxLazy = '1'; lazyVideo(v); } });
  }

  function boot() {
    nav();
    initIn(document);
    window.addEventListener('load', function () { setHeaderVar(); ScrollTrigger.refresh(); });
    var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(function () { setHeaderVar(); ScrollTrigger.refresh(); }, 200); });
    document.addEventListener('shopify:section:load', function (e) { initIn(e.target); ScrollTrigger.refresh(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
